// extracted by mini-css-extract-plugin
module.exports = {"container":"dc","content":"dd","image":"de","text":"df","form":"dg","button":"dh"};